"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSchema = void 0;
const zod_1 = require("zod");
exports.requestSchema = zod_1.z.object({
    propertyIds: zod_1.z.number().array(),
    years: zod_1.z.number().array(),
});
//# sourceMappingURL=almondHullSplit.js.map